<template>
  <div class="calico-card">
    <button
      :class="{ inline, stack: !inline }"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="$attrs"
    >
      <div
        v-if="imgSrc"
        class="image"
      >
        <img :src="imgSrc">
      </div>
      <div class="content">
        <h3 class="heading--xsmall">
          {{ title }}
        </h3>
        <p class="body--medium">
          {{ description }}
        </p>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "CalicoCard",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    imgSrc: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: ""
    },
    inline: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss">
.calico-card {
  height: fit-content;
  button {
    padding: 0;
    background: $color-white;
    border: 1px solid $color-neutral-light;
    border-radius: $radius-large;
    text-align: left;
    overflow: hidden;
    align-items: stretch;
    &:hover {
      background: $color-neutral-lightest;
    }

    &:active {
      background: $color-lapis-lightest;
    }

    &:disabled {
      background: $color-neutral-light;
      color: $color-neutral-dark;
    }
  }

  .image {
    display: flex;
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    img {
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  .stack {
    @include stack-space($space-none);
    .image {
      height: 100px;
    }

    .content {
      @include inset-space($space-medium);
      @include stack-space($space-small);
      h3,
      p {
        margin: 0;
      }
    }
  }

  .inline {
    @include inline-space($space-none);
    align-items: stretch;
    .image {
      width: 200px;
    }

    .content {
      @include inset-space($space-medium);
      @include stack-space($space-small);
      h3,
      p {
        margin: 0;
      }
    }
  }
}
</style>